export default "/_next/static/images/carousel-left-arrow-69b752c50ca7196ff9c85e7b308a0ad6.svg";